export const set = (obj, path, value) => {
  const keys = path.split('.');
  const key = keys.pop();

  let parent = obj;

  for (let key of keys) {
    const isArray = key?.match(/\[\d+\]/);
    if (isArray) {
      const index = parseInt(isArray[0].replace('[', '').replace(']', ''));
      key = key.replace(isArray[0], '');

      if (parent[key] === undefined) {
        parent[key] = [];
      }

      parent = parent[key][index];
      continue;
    }

    if (parent[key] === undefined) {
      parent[key] = {};
    }

    parent = parent[key];
  }

  if (parent && key) {
    if (Array.isArray(parent)) {
      const [match] = key?.match(/\[\d+\]/);
      const index = parseInt(match.replace('[', '').replace(']', ''));
      parent[index] = value;
    } else {
      parent[key] = value;
    }
  }
};

export const get = (obj, path) => {
  const keys = path.split('.');

  return keys.reduce((acc, key) => {
    const isArray = key?.match(/\[\d+\]/);
    if (isArray) {
      const index = parseInt(isArray[0].replace('[', '').replace(']', ''));
      key = key?.replace(isArray[0], '');
      return acc?.[key]?.[index];
    }
    return acc?.[key];
  }, obj);
};
